import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountComponent } from './components/account/account.component';
import { AcheminementComponent } from './components/acheminement/acheminement.component';
import { AdministrationComponent } from './components/administration/administration.component';
import { AgencyComponent } from './components/agency/agency.component';
import { CallForTenderListComponent } from './components/call-for-tender-list/call-for-tender-list.component';
import { CallForTenderComponent } from './components/call-for-tender/call-for-tender.component';

import { CombustibleComponent } from './components/combustible/combustible.component';
import { EmailComponent } from './components/email/email.component';
import { EnergieComponent } from './components/energie/energie.component';
import { EnginComponent } from './components/engin/engin.component';
import { AtelierComponent } from './components/atelier/atelier.component';
import { FormulaComponent } from './components/formula/formula.component';
import { IndustrieComponent } from './components/industrie/industrie.component';
import { IndustrieValidationComponent } from './components/industrie-validation/industrie-validation.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginComponent } from './components/login/login.component';
import { InscriptionComponent } from './components/inscription/inscription.component';
import { SsoComponent } from './components/sso/sso.component';
import { MemberComponent } from './components/member/member.component';

import { ProductComponent } from './components/product/product.component';
import { ProjectComponent } from './components/project/project.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { StatisticComponent } from './components/statistic/statistic.component';
import { StatisticProfileComponent } from './components/statistic/statisticProfile.component';

import { SyntheseComponent } from './components/synthese/synthese.component';

import { TransportComponent } from './components/transport/transport.component';
import { UserEntityComponent } from './components/user-entity/user-entity.component';
import { UserComponent } from './components/user/user.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { HelpComponent } from './components/help/help.component';
import { PartnerApiComponent } from './components/partner-api/partner-api.component';
import { WorkInspectionComponent } from './components/work-inspection/work-inspection.component';
import { TranslationComponent } from './components/translation/translation.component';
import { SiteMapUrl } from './core/_enums/sitemap.url';
import { AuthGuard } from './core/_helpers/auth.guard';
import { CanDeactivateGuard } from './core/_helpers/save.guard';
import { DredgingEquipmentInfoComponent } from './components/dredging-equipment-info/dredging-equipment-info.component';
import { TunnelingEquipmentInfoComponent } from './components/tunneling-equipment-info/tunneling-equipment-info.component';
import { DredgingFuelComponent } from './components/dredging-fuel/dredging-fuel.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: SiteMapUrl.MenuProject,
        children: [
          { path: ':id', component: ProjectComponent, canDeactivate: [CanDeactivateGuard] },
          { path: '', component: WelcomeComponent },
          { path: `${SiteMapUrl.MenuSynthese}/:id`, component: SyntheseComponent }
        ]
      },
      {
        path: SiteMapUrl.MenuAcheminement,
        children: [
          { path: ':id', component: AcheminementComponent, canDeactivate: [CanDeactivateGuard] },
          { path: 'new/:id', component: AcheminementComponent, canDeactivate: [CanDeactivateGuard] }
        ]
      },
      {
        path: SiteMapUrl.MenuProductFormula,
        children: [
          { path: 'p/:id', component: ProductComponent, canDeactivate: [CanDeactivateGuard] },
          { path: 'f/:id', component: FormulaComponent, canDeactivate: [CanDeactivateGuard] },
          { path: 'new/f/:id', component: FormulaComponent, canDeactivate: [CanDeactivateGuard] },
          { path: 'new/p/:id', component: ProductComponent, canDeactivate: [CanDeactivateGuard] }
        ]
      },
      {
        path: SiteMapUrl.MenuEnginAtelier,
        children: [
          { path: 'engin/new', component: EnginComponent },
          { path: 'engin/:id', component: EnginComponent },
          { path: 'atelier/new', component: AtelierComponent },
          { path: 'atelier/:id', component: AtelierComponent },
          {
            path: SiteMapUrl.MenuDredgingEquipment,
            component: DredgingEquipmentInfoComponent
          },
          {
            path: SiteMapUrl.MenuTunnelingEquipment,
            component: TunnelingEquipmentInfoComponent
          }
        ]
      },
      {
        path: SiteMapUrl.MenuDredgingFuel,
        children: [
          { path: ':id', component: DredgingFuelComponent },
          { path: 'new/:id', component: DredgingFuelComponent }
        ]
      },
      {
        path: SiteMapUrl.MenuCombustible,
        children: [
          { path: ':id', component: CombustibleComponent },
          { path: 'new/:id', component: CombustibleComponent }
        ]
      },
      {
        path: SiteMapUrl.MenuIndustry,
        children: [
          { path: '', component: IndustrieValidationComponent },
          { path: ':id', component: IndustrieComponent },
          { path: 'new/:id', component: IndustrieComponent },
          { path: 'formula/:id', component: FormulaComponent }
        ]
      },
      {
        path: SiteMapUrl.MenuTransport,
        children: [
          { path: ':id', component: TransportComponent, canDeactivate: [CanDeactivateGuard] },
          { path: 'new/:id', component: TransportComponent, canDeactivate: [CanDeactivateGuard] }
        ]
      },
      {
        path: SiteMapUrl.MenuEnergie,
        children: [
          { path: 'vehicle/:id', component: EnergieComponent, data: { energyType: 'vehicle' } },
          { path: 'vehicle/new/:id', component: EnergieComponent, data: { energyType: 'vehicle' } },
          { path: 'transportation/:id', component: EnergieComponent, data: { energyType: 'transportation' } },
          { path: 'transportation/new/:id', component: EnergieComponent, data: { energyType: 'transportation' } }
        ]
      },
      {
        path: SiteMapUrl.MenuOrganisation,
        children: [
          { path: ':id', component: AgencyComponent },
          { path: 'new/:id', component: AgencyComponent }
        ]
      },
      {
        path: SiteMapUrl.MenuEmail,
        component: EmailComponent
      },
      {
        path: SiteMapUrl.MenuStatistic,
        component: StatisticComponent
      },
      {
        path: SiteMapUrl.MenuStatisticProfile,
        component: StatisticProfileComponent
      },
      {
        path: SiteMapUrl.MenuUser,
        children: [
          { path: ':id', component: UserComponent },
          { path: 'new/:id', component: UserComponent }
        ]
      },
      {
        path: SiteMapUrl.MenuMember,
        children: [
          { path: ':id', component: MemberComponent },
          { path: 'new/:id', component: MemberComponent }
        ]
      },
      {
        path: SiteMapUrl.MenuUserEntity,
        children: [
          { path: ':id', component: UserEntityComponent },
          { path: 'new/:id', component: UserEntityComponent }
        ]
      },
      {
        path: SiteMapUrl.MenuAdministration,
        component: AdministrationComponent
      },
      {
        path: SiteMapUrl.MenuAccount,
        component: AccountComponent
      },
      {
        path: SiteMapUrl.MenuWorkInspection,
        children: [
          { path: '', component: WelcomeComponent },
          { path: ':id', component: WorkInspectionComponent, canDeactivate: [CanDeactivateGuard] }
        ]
      },
      {
        path: SiteMapUrl.MenuHelp,
        component: HelpComponent
      },
      {
        path: SiteMapUrl.MenuPartnerApi,
        component: PartnerApiComponent
      },
      {
        path: SiteMapUrl.MenuCallForTender,
        children: [
          { path: ':id', component: CallForTenderComponent },
          { path: '', component: CallForTenderListComponent }
        ]
      },
      {
        path: SiteMapUrl.MenuTranslation,
        component: TranslationComponent
      }
    ],
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'login',
    component: LoginComponent
    //{ path: '**', redirectTo: '' }
  },
  {
    path: 'inscription',
    component: InscriptionComponent
  },
  {
    path: SiteMapUrl.MenuSso,
    component: SsoComponent
  },
  {
    path: SiteMapUrl.MenuResetPassword,
    children: [{ path: ':id', component: ResetPasswordComponent }]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
